module.exports = __webpack_public_path__ + "img/pine.bda8caf.svg";